import { Grid, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { generatePath, useNavigate } from 'react-router'
import { type ImplementationTimeSpan } from '../../../models/ImplementationTimeSpan'
import { GetImplementationTimeSpans } from '../../../services/ImplementationService'
import { AppRoutes } from '../../Routes'
import { SummaryCard } from '../../customComponents/SummaryCard'
import { FormatDateAsTimeAgo } from '../../../utils/dateUtils'
import { handleApiResponse } from '../../../utils/apiHelpers'

export const CETADataTools = (): JSX.Element => {
  const nav = useNavigate()

  const [timeSpans, setTimeSpans] = useState<ImplementationTimeSpan[]>([])

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const implementationTimeSpans = await handleApiResponse(GetImplementationTimeSpans())
      if (implementationTimeSpans != null) setTimeSpans(implementationTimeSpans)
    }

    void fetchData()
  }, [])

  const goToPage = (timeSpan: ImplementationTimeSpan): void => {
    const route = generatePath(AppRoutes.IMPLEMENTATION_CETA, { timeSpanId: timeSpan.id.toString() })
    nav(route)
  }

  return (
    <>
      <Grid container spacing={2} sx={{ mt: '2em' }}>
        {timeSpans.map(timeSpan => (
          <Grid item key={timeSpan.id}>
            <SummaryCard
              superTitle='Implementation Plan'
              title={`${timeSpan.startYear}/${timeSpan.startYear + 1}`}
              content='CETA'
              footerContent={
                <>
                  {timeSpan.lastUpdated != null &&
                    <Typography variant='body2'>{FormatDateAsTimeAgo(timeSpan.lastUpdated)}</Typography>
                }
                </>
            }
              dataTestId={`${timeSpan.startYear}-card`}
              onClick={() => { goToPage(timeSpan) }}
            />
          </Grid>
        ))}
      </Grid>
    </>
  )
}
